export const TopNavbarSkeleton = () => {
  return (
    <>
      {/* Add a global CSS variable for the navbar height */}
      <style jsx global>{`
        :root {
          --top-navbar-height: 52px;
        }
      `}</style>

      <div className="w-full bg-white border-b border-[#E4E8EA] z-20 fixed top-0 left-0 right-0 h-[var(--top-navbar-height)]">
        <div className="max-w-[1920px] mx-auto px-6 relative h-full">
          <div className="flex items-center justify-between h-full gap-4">
            {/* Logo Section with PromptBar Skeleton */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 flex-shrink-0">
                <div className="w-6 h-6 rounded-md bg-gray-200 animate-pulse"></div>
                <div className="h-6 w-28 bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              {/* Prompt Bar Skeleton */}
              <div className="hidden md:block lg:flex-grow max-w-[460px] ml-2 sm:ml-4 md:ml-6 lg:ml-[84px] h-10 bg-gray-100 rounded-full px-3 items-center">
                <div className="w-4 h-4 rounded-full bg-gray-200 animate-pulse mr-2"></div>
                <div className="h-4 flex-grow bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>

            {/* Right Side Elements Skeleton */}
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="hidden sm:block h-4 w-20 bg-gray-200 rounded-md animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Add a spacer div to push content below the navbar */}
      <div className="h-[var(--top-navbar-height)] w-full"></div>
    </>
  );
};
